import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'

import { FaUserEdit } from "react-icons/fa";
import { GoUpload } from 'react-icons/go';
import { ImUpload2 } from 'react-icons/im';
import { LiaEyeSlashSolid, LiaEyeSolid } from 'react-icons/lia';
import { RiGalleryUploadLine, RiUploadCloud2Fill } from 'react-icons/ri';


interface UserDetails {
  id: number;
  name: string;
  email: string;
  role: string;
  company_name: string;
  profile: string;
  point :number;
  Time :string;
  DOB:string;
  password: string;
  a_auth_code_yr4_ign: string;
  designation:string;
  company_address:string;
  about_company:string;
  company_website:string;

}


interface ReportStructure {
  InitiatedBy: number;
  approve: string;
  date: string;
  discussion_point: string;
  id: number;
  image: string;
  location: string;
  meetingWith: number;
  type: string;
}

interface ReferenceStructure {
  id: number;
  referenceTo: number;
  referenceBy: number;
  RefPerName: string;
  number: string;
  date: string;
}

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  desc: string;
  date: string;
  PresentMember:string;
}
interface pointstruc{
  id:number;
  type:string;
  data:number
}
const Profile = () => {
  const api = process.env.REACT_APP_API_URL as string;
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const[pointdata, setPointdata] = useState<pointstruc[]>([]);
 
    const[R2RReceived, setR2RReceived] = useState();
    const[Visitor, setVisitor] = useState();

     const [reportData, setReportData] = useState<ReportStructure[]>([]);
      const [referenceData, setReferenceData] = useState<ReferenceStructure[]>([]);

       const [newData, setNewData] = useState<NewsStructure[]>([]);
       useEffect (()=>{
        const fetch = async ()=>{
            try{
    
                const response = await axios.get(`${api}/auth/point`);
                setPointdata(response.data.data);
    
            }
            catch(error){
       
                //console.log('error fetching point', error);
            }
        }
        fetch();
    })
   

       useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get<NewsStructure[]>(
              `${api}/auth/news`
            );
    
            //console.log('news data',response.data)
            if (!Array.isArray(response.data)) {
              setNewData([response.data]); // Wrap the object in an array
            } else {
              setNewData(response.data); // Set directly if it's an array
            }
            //console.log("news data in a array",newData);
          } catch (error) {
            console.error("Post Not Found:", error);
          }
        };
    
        fetchData();
      }, []);

       useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get(`${api}/auth/reference`);
    
            // console.log("business data", response.data);
            setReferenceData(response.data.data);
            // console.log("report data in a array", reportData.length);
          } catch (error) {
            console.error("user Not Found:", error);
          }
        };
    
        fetchData();
      }, []);
    
      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get(`${api}/auth/memeberpoint`);
    
            // console.log("member data", response.data);
            setReportData(response.data);
            // console.log("report data in a array", reportData.length);
          } catch (error) {
            console.error("user Not Found:", error);
          }
        };
    
        fetchData();
      }, []);

    // Open modal
  const openModal = (postId: number) => {
    setSelectedUserId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedUserId(null);
    setIsModalOpen(false);
  };

  const openCompanyModal = (postId: number) => {
    setSelectedUserId(postId);
    setIsCompanyModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeCompanyModal = () => {
    setSelectedUserId(null);
    setIsCompanyModalOpen(false);
  };
    const [userdetails, setUserdetails] = useState<UserDetails | null>(null);
    useEffect(() => {
      const validateSession = async () => {
        try {
          // Validate the session and retrieve user ID
          const response = await axios.get(`${api}/auth/memberLoggedIn`, {
            withCredentials: true,
          });
          //console.log('Dashboard data:', response.data);
          const uid = response.data.user.id;
          //console.log(`Requesting user details with URL: ${api}/auth/user/${uid}`);
  
          // Fetch user details
          const userResponse = await axios.get(`${api}/auth/user/${uid}`, {
            withCredentials: true,
          });
          setUserdetails(userResponse.data); // Set user details in state
        } catch (error: any) {
        }
      };
  
      validateSession();
    }, []);

    const calculateR2RPoints = (reportData: any[], pointdata: any[], userdetails: any) => {
      // Get the count of initiated R2R by the user
      const initiatedByCount = reportData.filter(
        (items) => items.InitiatedBy === userdetails?.id && items.type === 'R2R'
      ).length;
    
      // Get the sum of points for R2RHost
      const r2rHostSum = pointdata.filter(
        (items) => items.type === 'R2RHost'
      ).reduce((sum, item) => sum + item.data, 0);
    
      // Get the count of meetings with the user as guest
      const meetingWithCount = reportData.filter(
        (items) => items.meetingWith === userdetails?.id && items.type === 'R2R'
      ).length;
    
      // Get the sum of points for R2RGuest
      const r2rGuestSum = pointdata.filter(
        (items) => items.type === 'R2RGuest'
      ).reduce((sum, item) => sum + item.data, 0);
    
      // Calculate the final result
      const result = (initiatedByCount * r2rHostSum) + (meetingWithCount * r2rGuestSum);
    
      // Return all relevant values and the result
      return result;
    };

    const calculateVisitorPoints = (reportData: any[], pointdata: any[], userdetails: any) => {
      // Get the count of initiated R2R by the user
      const visitor = reportData.filter(
        (items) => items.InitiatedBy === userdetails?.id && items.type === 'Visitor'
      ).length;
    
      // Get the sum of points for R2RHost
      const r2rHostSum = pointdata.filter(
        (items) => items.type === 'R2RHost'
      ).reduce((sum, item) => sum + item.data, 0);
    
    
    
      // Calculate the final result
      const result = (visitor * r2rHostSum);
    
      // Return all relevant values and the result
      return result;
    };

    const calculateReferencePoints = (referenceData: any[], pointdata: any[], userdetails: any) => {
      // Get the count of initiated R2R by the user
      const visitor = referenceData.filter(
        (items) => items.referenceBy === userdetails?.id
      ).length;
    
      // Get the sum of points for R2RHost
      const r2rHostSum = pointdata.filter(
        (items) => items.type === 'Reference'
      ).reduce((sum, item) => sum + item.data, 0);
    
    
    
      // Calculate the final result
      const result = (visitor * r2rHostSum);
    
      // Return all relevant values and the result
      return result;
    };
    
    const calculatePresentPoints = (newData: any[], pointdata: any[], userdetails: any) => {


      const totalPresence = newData.reduce((count, items) => {
        const premebArray = items.PresentMember ? JSON.parse(items.PresentMember) : [];
        // console.log('PremebArray:', premebArray); // Debug log for the array
      
        const isPresent = premebArray.some((pid: any) => {
          const match = pid.id === userdetails?.id && pid.status === 'present';
          return match;
        });
      
        return isPresent ? count + 1 : count;
      }, 0);

      const totalLate = newData.reduce((count, items) => {
        const premebArray = items.PresentMember ? JSON.parse(items.PresentMember) : [];
        // console.log('PremebArray:', premebArray); // Debug log for the array
      
        const isLate = premebArray.some((pid: any) => {
          const match = pid.id === userdetails?.id && pid.status === 'late';
          return match;
        });
      
        return isLate ? count + 1 : count;
      }, 0);
      
      const totalSubstitute = newData.reduce((count, items) => {
        const premebArray = items.PresentMember ? JSON.parse(items.PresentMember) : [];
        // console.log('PremebArray:', premebArray); // Debug log for the array
      
        const isSubstitute = premebArray.some((pid: any) => {
          const match = pid.id === userdetails?.id && pid.status === 'substitute';
          return match;
        });
      
        return isSubstitute ? count + 1 : count;
      }, 0);
      
    
      // Get the sum of points for R2RHost
      const r2rHostSum = pointdata.filter(
        (items) => items.type === 'Attendance'
      ).reduce((sum, item) => sum + item.data, 0);
    
      const r2rLateSum = pointdata.filter(
        (items) => items.type === 'Late'
      ).reduce((sum, item) => sum + item.data, 0);

      const r2rSubstituteSum = pointdata.filter(
        (items) => items.type === 'Substitute'
      ).reduce((sum, item) => sum + item.data, 0)
    
    
      // Calculate the final result
      const result = (totalPresence * r2rHostSum) + (totalLate*r2rLateSum) + (totalSubstitute*r2rSubstituteSum);
    
      // Return all relevant values and the result
      return result;
    };

  return (
    <div className="min-h-screen bg-[rgb(30,42,58)] text-white font-sans p-[3%]">
      {/* Main Container */}
      <div className="container mx-auto  px-4 lg:px-0">
        {/* Profile Section */}
        <div className="bg-[rgb(52,64,86)] rounded-lg p-6 flex flex-col items-center relative">
          <img
            src={`${api}/${userdetails?.profile}`}
            alt={`${userdetails?.name}`}
            className="w-24 h-24 rounded-full mb-4 object-cover"
          />
          <h2 className="text-2xl font-semibold">{userdetails?.name}</h2>
          <p className="text-gray-400 text-sm text-center mt-2">
            {userdetails?.company_name}
            <br />
            {userdetails?.role}
          </p>

          <div className="w-fit flex justify-between mt-3 absolute right-4 top-2">
            <button
              className="bg-[#fdbc12] rounded w-[110px] text-darkblue text-[17px] font-medium py-2 flex justify-center items-center gap-2"
              onClick={() => openModal(userdetails?.id as number)}
            >
              <FaUserEdit /> Edit
            </button>
          </div>
          {isModalOpen && !isCompanyModalOpen &&(
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg w-[50%] h-auto">
                {/* Close button */}
                {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
         X
       </button> */}
                <Modal userId={selectedUserId} onClose={closeModal} />
              </div>
            </div>
          )}
        </div>

        {/* About Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8">
          {/* Main About Section */}
          <div className="lg:col-span-2 bg-[rgb(52,64,86)] rounded-lg p-6 space-y-6">
            {/* Profile Header */}
            <div className="flex items-center gap-4">
              <div>
                <h3 className="text-xl font-semibold text-white">
                  {userdetails?.name || "Name not provided"}
                </h3>
                <p className="text-gray-400 text-sm">
                  {userdetails?.email || "Email not provided"}
                </p>
              </div>
            </div>

            {/* Details Section */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <h4 className="text-lg font-medium text-gray-200">Role</h4>
                <p className="text-gray-400">
                  {userdetails?.role || "Not specified"}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-medium text-gray-200">
                  Company Name
                </h4>
                <p className="text-gray-400">
                  {userdetails?.company_name || "Not specified"}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-medium text-gray-200">
                  Classification
                </h4>
                <p className="text-gray-400">
                  {userdetails?.designation || "Not specified"}
                </p>
              </div>

              <div>
                <h4 className="text-lg font-medium text-gray-200">
                  Date of Birth
                </h4>
                <p className="text-gray-400">
                  {userdetails?.DOB.split("T")[0] || "Not specified"}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-medium text-gray-200">
                  Joining Date
                </h4>
                <p className="text-gray-400">
                  {userdetails?.Time.split("T")[0] || "Not specified"}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-medium text-gray-200">Password</h4>
                <p className="text-gray-400">{"******"}</p>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div>
            {/* Point */}
            <div
              className="bg-[rgb(52,64,86)] rounded-lg p-6 mb-8"
              id="profile"
            >
              <h3 className="text-xl font-semibold mb-4">Point</h3>
              <div className="flex space-x-4">
                <p className="text-xl font-semibold mb-4 text-textyellow">
                  {userdetails?.point}
                </p>
              </div>
            </div>

            {/* Community Karma */}
            <div className="bg-[rgb(52,64,86)] rounded-lg p-6 ">
              <h3 className="text-xl font-semibold mb-4">Activity</h3>

              <ul className="space-y-2">
                <li className="text-gray-400">
                  R2R: {calculateR2RPoints(reportData, pointdata, userdetails)}
                </li>
                <li className="text-gray-400">
                  Visitors:{" "}
                  {calculateVisitorPoints(reportData, pointdata, userdetails)}
                </li>
                <li className="text-gray-400">
                  Reference:{" "}
                  {calculateReferencePoints(
                    referenceData,
                    pointdata,
                    userdetails
                  )}
                </li>
                <li className="text-gray-400">
                  Present :{" "}
                  {calculatePresentPoints(newData, pointdata, userdetails)}
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Company Details*/}
        <div className="bg-[rgb(52,64,86)] rounded-lg p-6 mt-8  flex flex-col items-center relative">
          <h2 className="text-2xl font-semibold">Company Details</h2>

          <div className="grid grid-cols-2 gap-4 justify-between w-full mt-6">
            <div className="flex items-center gap-2">
              <h4 className="text-lg font-medium text-gray-200">
                Company Name :{" "}
              </h4>
              <p className="text-gray-400">
                {userdetails?.company_name || "Not specified"}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <h4 className="text-lg font-medium text-gray-200">
                About Company :{" "}
              </h4>
              <p className="text-gray-400">
                {userdetails?.about_company || "Not specified"}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <h4 className="text-lg font-medium text-gray-200">
                Company Address :{" "}
              </h4>
              <p className="text-gray-400">
                {userdetails?.company_address || "Not specified"}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <h4 className="text-lg font-medium text-gray-200">
                Company Website :{" "}
              </h4>
              <p className="text-gray-400">
                {userdetails?.company_website || "Not specified"}
              </p>
            </div>
          </div>
          <div className="w-fit flex justify-between mt-3 absolute right-4 top-2">
                
                <button className="bg-[#fdbc12] rounded w-[110px] text-darkblue text-[17px] font-medium py-2 flex justify-center items-center gap-2" onClick={() => openCompanyModal(userdetails?.id as number)}><FaUserEdit/> Edit</button>
             </div>
             {isCompanyModalOpen && !isModalOpen &&(
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg w-[50%] h-auto">
              {/* Close button */}
              {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
         X
       </button> */}
              <CompanyModal userId={selectedUserId} onClose={closeCompanyModal} />
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}



interface ModalProps {
  userId?: number | null;
  onClose: () => void;
}

// Decrypt function
const Modal: React.FC<ModalProps> = ({ userId, onClose }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown menu visibility
  const api = process.env.REACT_APP_API_URL as string;
  const dropdownRef = useRef<HTMLDivElement | null>(null); // Type the ref here
  // Reference for the dropdown menu

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [selectedImagePath, setSelectedImagePath] = useState<string | null>(
    null
  );

  const handleImageSelect = (path: string) => {
    setSelectedImagePath(path); // Save the selected path in the parent component
    // setFormData((prev) => ({ ...prev, image:  }));
    setFileName(path);
    //console.log("Selected Image Path:", path);
  };

  const closegallery = () => {
    setGallery(false);
  };

  const [gallery, setGallery] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Extracts yyyy-MM-dd
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "",
    company_name: "",
    designation: "",
    image: null as File | null,
    password: "",
    DOB:"",
    Time:"",
  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (userId != -1) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(
            `${api}/auth/user/${userId}`
          );

          const data = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          // Access the first element

          // Destructure from the first element of the array
          const {
            name,
            email,
            role,
            company_name,
            designation,
            profile: image,
            password,
            a_auth_code_yr4_ign,
            DOB,
            Time,
          } = data;

          //console.log("name:", name);
          //console.log("email:", email);
          //console.log("role:", role);
          //console.log("company_name:", company_name);
          //console.log("image path: ", image);

          const smptextpsd = 	a_auth_code_yr4_ign.slice(3, -3);
          

          setFormData({
            name,
            email,
            role,
            company_name,
            designation,
            password:smptextpsd,
            image: image || null,
            DOB:formatDate(DOB),
            Time:formatDate(Time)
          });

          setFileName(image);
        } catch (err) {
          console.error("Error fetching users:", err);
        }
      };
      fetchPost();
    }
  }, [userId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);
    setSelectedImagePath(file ? file.name : null);
  };

  const closeGallery = () => {
    setGallery(false);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (!formData.name || !formData.password || !formData.email) {
      setError("All fields are required.");
      return;
    }

    const data = new FormData();
    data.append("name", formData.name);
    data.append("company_name", formData.company_name);
    data.append("designation", formData.designation);
    data.append("email", formData.email);
    data.append("role", formData.role);
    data.append("password", formData.password);
    data.append("DOB",formData.DOB);
    data.append("Time",formData.Time);
    if (formData.image) {
      data.append("image", formData.image);
    } else if (fileName) {
      data.append("image", fileName);
    }

    try {
      if (userId != -1) {
        await axios.put(`${api}/auth/member/${userId}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
       
      } else {
        await axios.post(`${api}/auth/member`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        
      }
      onClose();
      window.location.href = "/dashboard";
    } catch (err) {
      
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white lg:w-1/2 w-[98%] p-6 rounded shadow relative h-[96%] overflow-y-auto">
        <form onSubmit={handleSubmit} className="space-y-4 grid ">
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2 text-slate-700">
            <div>
              <label className="text-[#030303] font-medium"> Member Name</label>
              <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter memeber name..."
                  className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
                  required
                />
              </div>
            </div>

            <div>
              <label className="text-[#030303] font-medium">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter email"
                required
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Date Of Birth</label>
              <input
                type="date"
                name="DOB"
                value={formData.DOB}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                
                required
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Date Of Joining</label>
              <input
                type="date"
                name="Time"
                value={formData.Time}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                
                required
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Classification</label>
              <input
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter designation"
                disabled
              />
            </div>

            <div>
              <label className="text-[#030303] font-medium">Role</label>
              <select
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                value={formData.role} // Bind to state
                onChange={
                  (e) => setFormData({ ...formData, role: e.target.value }) // Update the role in state
                }
                disabled
              >
                <option value="Member">Member</option>
                <option value="Leader">Leader</option>
                <option value="Coordinator">Coordinator</option>
              </select>
            </div>
            <div>
              <label className="text-[#030303] font-medium">Company Name</label>
              <input
                type="text"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block  h-[50px] w-full border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter company name"
                required
              />
            </div>
            <div className="relative">
              <label className="text-[#030303] font-medium">
                Enter Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="password" // Added name attribute for FormData
                className="w-full border  h-[50px] p-2 rounded mt-1"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter member password"
                required
              />
              <div className="absolute top-[57%] right-3 transform -translate-y-1/2 cursor-pointer">
                {!showPassword ? (
                  <LiaEyeSlashSolid onClick={() => setShowPassword(true)} /> // Show password icon
                ) : (
                  <LiaEyeSolid onClick={() => setShowPassword(false)} /> // Hide password icon
                )}
              </div>
            </div>
          </div>
          {/* File Upload */}
         
         
          <div className="hidden">
            <label className="text-[#030303] font-medium">
              Add Profile Photo
            </label>
            <div className="mt-1 w-[100%] h-[160px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
              {/* Icon for file upload */}
              <RiGalleryUploadLine
                size={24}
                className="text-[30px] cursor-pointer"
                onClick={() => document.getElementById("file-upload")?.click()}
              />
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name="image"
                onChange={handleFileChange}
              />

              {/* Choose Media from Library */}
              <div className="flex flex-col items-center">
                <button
                  type="button"
                  className="mt-2 flex items-center space-x-2 text-blue-500 hover:underline"
                  onClick={() => setGallery(true)}
                >
                  Choose Media From Library <ImUpload2 className="text-2xl" />
                </button>
              </div>

              {/* Modal for Gallery */}
              {gallery && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[50%] h-auto p-4 relative">
                    {/* GalleryModal with close button */}
                    <GalleryModal
                      onImageSelect={handleImageSelect}
                      onClose={closeGallery}
                    />
                    <button
                      className="absolute top-2 right-2 text-red-500 text-xl"
                      onClick={closeGallery}
                    >
                      X
                    </button>
                  </div>
                </div>
              )}

              {/* Display selected file or gallery image */}
              {selectedImagePath ? (
                <div className="mt-4">
                  <p className="text-[14px] text-[#02256d]">
                    Selected image:{" "}
                    <span className="font-bold">{selectedImagePath}</span>
                  </p>
                  <img
                    src={`${api}/${selectedImagePath}`}
                    alt="Selected"
                    className="w-24 h-24 rounded-md mt-2 object-cover"
                  />
                </div>
              ) : fileName ? (
                <p className="text-[14px] text-[#02256d] mt-2">
                  Selected file: <span className="font-bold">{fileName}</span>
                </p>
              ) : (
                <p className="font-bold text-[14px]">
                  Drag and Drop or{" "}
                  <span className="text-[#02256d]">click to upload</span>
                </p>
              )}
            </div>
          </div>

          <div className="relative">
            <label className="text-[#030303] font-medium">
              Add Profile Photo
            </label>
            <div className="mt-1 w-[100%] h-[120px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center cursor-pointer mb-4 relative" onClick={()=>setDropdownOpen((prev) => !prev)}>
              {/* Select Image button */}
              <button
                type="button"
                className="text-[30px] cursor-pointer"
               
              >
                <RiUploadCloud2Fill />             
              </button>

              {/* Dropdown menu for selecting Upload or Gallery */}
              {dropdownOpen && (
                <div
                  ref={dropdownRef}
                  className="absolute top-[70px] right-32 w-auto bg-white border border-gray-300 rounded-md shadow-lg z-10"
                >
                  <ul>
                    <li
                      className="p-2 cursor-pointer flex gap-2 justify-center items-center hover:bg-gray-200"
                      onClick={() =>
                        document.getElementById("file-upload")?.click()
                      }
                    >
                      Upload File <GoUpload/>
                    </li>
                    <li
                      className="p-2 cursor-pointer hover:bg-gray-200"
                      onClick={() => setGallery(true)}
                    >
                      Choose from Gallery
                    </li>
                  </ul>
                </div>
              )}

              {/* File upload input */}
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name="image"
                onChange={handleFileChange}
              />

              {/* Gallery modal */}
              {gallery && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[50%] h-auto p-4 relative">
                    <GalleryModal
                      onImageSelect={handleImageSelect}
                      onClose={closeGallery}
                    />
                    <button
                      className="absolute top-2 right-2 text-red-500 text-xl"
                      onClick={closeGallery}
                    >
                      X
                    </button>
                  </div>
                </div>
              )}

              {/* Display selected file or gallery image */}
              {selectedImagePath ? (
                <div className="mt-4">
                  <p className="text-[14px] text-[#02256d]">
                    Selected image:{" "}
                    <span className="font-bold">{selectedImagePath}</span>
                  </p>
                  {/* <img
                    src={`${api}/${selectedImagePath}`}
                    alt="Selected"
                    className="w-24 h-24 rounded-md mt-2 object-cover"
                  /> */}
                </div>
              ) : fileName ? (
                <p className="text-[14px] text-[#02256d] mt-2">
                  Selected file: <span className="font-bold">{fileName}</span>
                </p>
              ) : (
                <p className="font-bold text-[14px]">
                  Choose media{" "}
                  {/* <span className="text-[#02256d]">click to upload</span> */}
                </p>
              )}
            </div>
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            {/* Date */}

            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] text-darkblue border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-semibold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] text-darkblue rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                disabled={
                  !formData.password || !formData.name || !formData.email
                }
              >
                {userId != -1 ? "Update profile" : "Add User"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

interface CompanyModalProps {
  userId?: number | null;
  onClose: () => void;
}

// Decrypt function
const CompanyModal: React.FC<CompanyModalProps> = ({ userId, onClose }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown menu visibility
  const api = process.env.REACT_APP_API_URL as string;
  const dropdownRef = useRef<HTMLDivElement | null>(null); // Type the ref here
  // Reference for the dropdown menu

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const [formData, setFormData] = useState({
    
    company_name: "",
    company_address:"",
  about_company:"",
  company_website:"",

    
  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (userId != -1) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(
            `${api}/auth/user/${userId}`
          );

          const data = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          // Access the first element

          // Destructure from the first element of the array
          const {
            company_address,
            about_company,
            company_website,
            company_name,
          } = data;

          //console.log("name:", name);
          //console.log("email:", email);
          //console.log("role:", role);
          //console.log("company_name:", company_name);
          //console.log("image path: ", image);

          

          setFormData({
            company_address,
            about_company,
            company_website,
            company_name,
          });

        } catch (err) {
          console.error("Error fetching users:", err);
        }
      };
      fetchPost();
    }
  }, [userId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (!formData.about_company || !formData.company_address || !formData.company_website || !formData.company_name) {
      setError("All fields are required.");
      return;
    }

    const data = new FormData();
    data.append("company_address:", formData.company_address);
    data.append("company_name", formData.company_name);
    data.append("company_website", formData.company_website);
    data.append("about_company", formData.about_company);
    try{
      if (userId != -1) {
        await axios.put(`${api}/auth/member/${userId}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
       
      } else {
        await axios.post(`${api}/auth/member`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        
      }
      onClose();
      window.location.href = "/dashboard";
    } catch (err) {
      
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white lg:w-1/2 w-[98%] p-6 rounded shadow relative h-auto overflow-y-auto">
        <form onSubmit={handleSubmit} className="space-y-4 grid ">
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2 text-slate-700">
            <div>
              <label className="text-[#030303] font-medium">About Company</label>
              <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
                <input
                  type="textarea"
                  name="about_company"
                  value={formData.about_company}
                  onChange={handleChange}
                  placeholder="Enter About Company"
                  className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
                  required
                />
              </div>
            </div>

            <div>
              <label className="text-[#030303] font-medium">Company Address</label>
              <input
                type="text"
                name="company_address"
                value={formData.company_address}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter Company Address"
                required
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Company Website</label>
              <input
                type="text"
                name="company_website"
                value={formData.company_website}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter Company Website"
                required
              />
            </div>
            
          

            
            <div>
              <label className="text-[#030303] font-medium">Company Name</label>
              <input
                type="text"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block  h-[50px] w-full border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter company name"
                required
              />
            </div>
           
          </div>
          {/* File Upload */}
         
         
        

        

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            {/* Date */}

            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] text-darkblue border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-semibold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] text-darkblue rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                disabled={
                  !formData.about_company || !formData.company_address || !formData.company_website
                }
              >
                {userId != -1 ? "Update profile" : "Add User"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

interface Gallery {
  id: number;
  name: string;
  path: string;
}

interface GalleryModalProps {
  onImageSelect: (path: string) => void; // Callback function to return selected image path
  onClose: () => void;
}

const GalleryModal: React.FC<GalleryModalProps> = ({
  onImageSelect,
  onClose,
}) => {
  const [mediaData, setMediaData] = useState<Gallery[]>([]);
  const [selected, setSelected] = useState("");
  const api = process.env.REACT_APP_API_URL as string;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/media`);

        if (Array.isArray(response.data.data)) {
          setMediaData(response.data.data);
        } else {
          console.error("Response is not an array:", response.data);
        }
      } catch (error) {
        console.error("Error fetching media data:", error);
      }
    };

    fetchData();
  }, []);

  const handleImageSelect = (path: string) => {
    onImageSelect(path); // Pass the selected image path to the parent component
    setSelected(path);
  };

  return (
    <div className="p-4">
      <h1 className="text-lg font-bold mb-4">Choose media from here</h1>
      {mediaData.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2 h-[340px] overflow-y-auto">
          {mediaData.map((imagedata) => (
            <div
              className={`w-full aspect-square border cursor-pointer ${
                selected && imagedata.path === selected
                  ? "border-2 border-blue-500 opacity-35"
                  : ""
              }`}
              key={imagedata.id}
              onClick={() => handleImageSelect(imagedata.path)}
            >
              <img
                src={`${api}/${imagedata.path}`}
                alt={imagedata.name || "Media item"}
                className="object-cover w-full h-full rounded-md shadow-md"
              />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">
          No media available to display.
        </p>
      )}
      <div
        className="w-[90px] h-[45px] bg-blue-500 text-white flex justify-center items-center rounded mt-2 cursor-pointer"
        onClick={onClose}
      >
        Select file
      </div>{" "}
      {selected}
    </div>
  );
};

export default Profile